var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10h2v7h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2v2h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionInfo);
export default __webpack_public_path__ + "static/media/ic_action_info.70752524b31869e2cd4fa3424d921d59.svg";
export { ForwardRef as ReactComponent };